import React from 'react';
import Modal from '../../../components/ui/modal';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../state/reducers';
import { useCommonContext } from '../../../contexts/common';
import { actions } from '../../../state/actions/actionsWrapper';
import ModalActions from '../../../components/ui/modal/ModalActions';
import Button from '../../../components/ui/button';
import { Controller, useForm } from 'react-hook-form';
import { ILegalGroup } from '../../../models/response/legal-document/ILegalGroup';
import { Box, Checkbox, FormControl } from '@primer/react';
import Text from '../../../components/ui/text';
import TextInput from '../../../components/ui/text-input';
import { ePageBaseStatus } from '../../../models/ePageBaseStatus';

const LegalGroupEditModal = () => {
    const { status, groupEditing } = useSelector((x: RootState) => x.legalDocument.group)
    const dispatch = useDispatch();
    const { translate } = useCommonContext();
    const { register, handleSubmit, clearErrors, reset, setError, control, formState: { errors } } = useForm<ILegalGroup>({
        defaultValues: {
            ...groupEditing
        }
    })
    const onSubmit = (data: ILegalGroup) => {
        console.log({
            data
        });
        dispatch(actions.legalDocument.group.SAVE_START({
            ...data,
            id: groupEditing?.id ?? 0
        }))

    }
    return (
        <Modal
            title={groupEditing ? translate(`Base.Label.Update`) : translate(`Base.Label.AddNew`)}
            isOpen
            onClose={() => {
                dispatch(actions.legalDocument.group.CLOSE_EDIT_MODAL(undefined))
            }}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{
                    display: "grid",
                    gap: 2
                }}>
                    <FormControl>
                        <FormControl.Label><Text text='LegalGroup.Name' /></FormControl.Label>
                        <TextInput
                            block
                            errors={errors}
                            register={register}
                            required={true}
                            name='name'
                            validateMessage={`${translate(`Base.Form.RequiredMessage`)} ${translate(`LegalGroup.Name`)}`}
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label><Text text='LegalGroup.NameEn' /></FormControl.Label>
                        <TextInput
                            block
                            errors={errors}
                            register={register}
                            required={true}
                            name='name_en'
                            validateMessage={`${translate(`Base.Form.RequiredMessage`)} ${translate(`LegalGroup.NameEn`)}`}
                        />
                    </FormControl>
                    <Controller
                        control={control}
                        name="is_active"
                        rules={{
                            required: {
                                value: false,
                                message: ""
                            }
                        }}
                        render={({ field }) => (
                            <>
                                <FormControl>
                                    <FormControl.Label><Text text='LegalGroup.IsActive' /></FormControl.Label>
                                    <Checkbox checked={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.target.checked)
                                        }}
                                    />
                                </FormControl>
                            </>
                        )}
                    />
                </Box>
                <ModalActions>
                    <Button text='Base.Label.Close'
                        size='medium'
                        onClick={() => {
                            dispatch(actions.legalDocument.group.CLOSE_EDIT_MODAL(undefined))
                        }}
                    />
                    <Button text={groupEditing ? translate(`Base.Label.Update`) : translate(`Base.Label.AddNew`)}
                        variant='primary'
                        type='submit'
                        size='medium'
                        isLoading={status === ePageBaseStatus.is_saving}
                    />
                </ModalActions>
            </form>
        </Modal>
    );
};

export default LegalGroupEditModal;